import service from "@irati/utils/tracking/index"

const tracking = {
  editProfile: () => {
    service.trackEvent("admin_dashboard_edit_profile")
  },
  viewPeople: () => {
    service.trackEvent("admin_dashboard_view_people")
  },
  addSinglePerson: () => {
    service.trackEvent("admin_dashboard_add_single")
  },
  addBulkPeople: () => {
    service.trackEvent("admin_dashboard_add_bulk")
  },
  viewTeams: () => {
    service.trackEvent("admin_dashboard_view_teams")
  },
  addTeam: () => {
    service.trackEvent("admin_dashboard_add_team")
  },
  viewCustomisation: () => {
    service.trackEvent("admin_dashboard_view_customisation")
  },
  updateBrand: () => {
    service.trackEvent("admin_dashboard_update_brand")
  },
  addBenefit: () => {
    service.trackEvent("admin_dashboard_add_benefit")
  },
  perkVisibility: () => {
    service.trackEvent("admin_dashboard_perk_visibility")
  },
  viewRoles: () => {
    service.trackEvent("admin_dashboard_view_roles")
  },
  recognitionPermissions: () => {
    service.trackEvent("admin_dashboard_recognition_permissions")
  },
  viewLogin: () => {
    service.trackEvent("admin_dashboard_view_login")
  },
  enableSignUp: () => {
    service.trackEvent("admin_dashboard_ssu")
  },
  setUpSingleSignOn: () => {
    service.trackEvent("admin_dashboard_sso")
  },
  viewReports: () => {
    service.trackEvent("admin_dashboard_view_reports")
  },
  viewHelp: () => {
    service.trackEvent("admin_dashboard_view_help")
  },
  viewRegions: () => {
    service.trackEvent("admin_dashboard_viewregions")
  },
  viewRegionsTab: () => {
    service.trackEvent("admin_dashboard_navtab_regions")
  },
  viewPeopleTab: () => {
    service.trackEvent("admin_dashboard_navtab_people")
  },
  viewTeamsTab: () => {
    service.trackEvent("admin_dashboard_navtab_teams")
  },
  viewSettingsTab: () => {
    service.trackEvent("admin_dashboard_navtab_settings")
  },
  viewReportingTab: () => {
    service.trackEvent("admin_dashboard_navtab_reporting")
  },
  viewHelpTab: () => {
    service.trackEvent("admin_dashboard_navtab_help")
  },
  clickResourceHub: () => {
    service.trackEvent("admin_dashboard_resourceHub")
  },
  clickAddPeopleCTA: () => {
    service.trackEvent("admin_dashboard_addPeopleCTA")
  },
  clickCreateTeamsCTA: () => {
    service.trackEvent("admin_dashboard_createTeamsCTA")
  },
  clickAddRegionCTA: () => {
    service.trackEvent("admin_dashboard_addRegionCTA")
  },
  downloadPeopleList: () => {
    service.trackEvent("admin_dashboard_downloadPeopleList")
  },
  viewDetailedReports: () => {
    service.trackEvent("admin_dashboard_viewDetailedReports")
  },
  filterWeekly: () => {
    service.trackEvent("admin_dashboard_filterWeekly")
  },
  filterMonthly: () => {
    service.trackEvent("admin_dashboard_filterMonthly")
  },
  clickInviteAdmin: () => {
    service.trackEvent("admin_dashboard_onboarding_inviteAdmin")
  },
  clickCustomBrand: () => {
    service.trackEvent("admin_dashboard_onboarding_customBrand")
  },
  clickCustomEmail: () => {
    service.trackEvent("admin_dashboard_onboarding_customEmail")
  },
  clickEnableSSO: () => {
    service.trackEvent("admin_dashboard_onboarding_enableSSO")
  },
  clickInvitePeopleUpload: () => {
    service.trackEvent("admin_dashboard_onboarding_invitePeopleUpload")
  },
  clickInvitePeopleDSYNC: () => {
    service.trackEvent("admin_dashboard_onboarding_invitePeopleDSYNC")
  },
  clickCreateTeams: () => {
    service.trackEvent("admin_dashboard_onboarding_createTeams")
  },
  clickAssignManagers: () => {
    service.trackEvent("admin_dashboard_onboarding_assignManagers")
  },
  clickAddCustomBenefits: () => {
    service.trackEvent("admin_dashboard_onboarding_addCustomBenefits")
  },
  clickAddCompanyValues: () => {
    service.trackEvent("admin_dashboard_onboarding_addCompanyValues")
  },
  clickAddCompanyCelebrations: () => {
    service.trackEvent("admin_dashboard_onboarding_addCompanyCelebrations")
  },
  clickLinkPeopleDirectory: () => {
    service.trackEvent("admin_dashboard_onboarding_linkPeopleDirectory")
  },
  clickEditCultureHub: () => {
    service.trackEvent("admin_dashboard_onboarding_editCultureHub")
  },
  submitReasons: (reasons: string[]) => {
    service.trackEvent("admin_dashboard_integrationsModule_clickDontShowAgain_clickSubmitReasons", {reasons})
  },
  clickFindOutMore: () => {
    service.trackEvent("admin_dashboard_integrationsModule_clickFindOutMore")
  },
  clickReadLess: () => {
    service.trackEvent("admin_dashboard_integrationsModule_clickReadLess")
  },
  clickNotShowAgain: () => {
    service.trackEvent("admin_dashboard_integrationsModule_clickDontShowAgain")
  },
  clickGetStartedSSO: () => {
    service.trackEvent("admin_dashboard_integrationsModule_clickGetStartedSSO")
  },
  clickGetStartedDsync: () => {
    service.trackEvent("admin_dashboard_integrationsModule_clickGetStartedDsync")
  },
  closeIntegrationModule: () => {
    service.trackEvent("admin_dashboard_integrationsModule_clickClose")
  },
  clickSendInvites: () => {
    service.trackEvent("admin_dashboard_bulkResendInvite_confirmSend_send")
  },
  clickRemoveInvites: () => {
    service.trackEvent("admin_dashboard_bulkResendInvite_confirmSend_removeInvitees")
  },
  clickAddInvites: () => {
    service.trackEvent("admin_dashboard_bulkResendInvite_confirmSend_addInvitees")
  },
  openSendInviteModule: () => {
    service.trackEvent("admin_dashboard_bulkResendInvite_start")
  },
  closeSendInviteModule: () => {
    service.trackEvent("admin_dashboard_bulkResendInvite_confirmSend_exit")
  },
  clickSendInvitesTellMeMore: () => {
    service.trackEvent("admin_dashboard_bulkResendInvite_integrationsTellMeMore")
  },
  clickSendInvitesMaybeLater: () => {
    service.trackEvent("admin_dashboard_bulkResendInvite_integrationsMaybeLater")
  },
  confirmIntegrationModuleReminder: () => {
    service.trackEvent("admin_dashboard_integrationsModule_close_confirmReminder")
  },
  clickRewardWalletRewardsModal: () => {
    service.trackEvent("modal_click_reward_wallet")
  },
  clickRewardsVideoRewardsModal: () => {
    service.trackEvent("modal_click_reward_video")
  },
  clickIntegrationSliderArrows: () => {
    service.trackEvent("admin_dashboard_integrationsModule_rotateValueStatements")
  },
  clickCatalogueSeeAllDeals: () => {
    service.trackEvent("admin_clickSeeAllDeals")
  },
  clickCatalogueSliderArrows: () => {
    service.trackEvent("admin_scroll_latestDealsAdded")
  },
  clickCatalogueDeal: () => {
    service.trackEvent("admin_clickedLatestDeal")
  }
}

export default tracking
